// tslint:disable:no-any
import { DictionaryEntry } from '.';
import {State} from './State';
// import {State as MainState} from 'FullVersion/Store'; TODO: move redux away from library

export const selectDictionaryStateFromMainState = (mainState: any): State => mainState.dictionaryState;
export const selectAddedEntries = (state: any): boolean => selectDictionaryStateFromMainState(state).addedEntries;
export const selectDictionaryEntries = (state: any): DictionaryEntry[] => selectDictionaryStateFromMainState(state).dictionaryEntries;
export const selectIsLoading = (state: any): boolean => selectDictionaryStateFromMainState(state).isLoading;